import React, { useRef, useEffect, useState } from 'react'
import styles from './styles.module.css'
import cn from 'classnames'

export default function Table({ children, className, maxHeight = '45vh', minHeight, dataLoaded, ...props }) {
  const tableRef = useRef(null)
  const [columnWidths, setColumnWidths] = useState(null)
  const classNames = cn([styles.table, className])

  useEffect(() => {
    if (dataLoaded && tableRef.current && !columnWidths) {
      const table = tableRef.current.querySelector('table')
      if (table) {
        const thead = table.querySelector('thead')
        if (thead) {
          const headerRow = thead.querySelector('tr')
          if (headerRow) {
            const headers = headerRow.querySelectorAll('th')
            const widths = Array.from(headers).map(th => {
              const rect = th.getBoundingClientRect()
              return rect.width
            })
            setColumnWidths(widths)
          }
        }
      }
    }
  }, [dataLoaded, columnWidths])

  useEffect(() => {
    if (columnWidths && tableRef.current) {
      const table = tableRef.current.querySelector('table')
      if (table) {
        const thead = table.querySelector('thead')
        const tbody = table.querySelector('tbody')
        if (thead && tbody) {
          const headerRow = thead.querySelector('tr')
          const rows = tbody.querySelectorAll('tr')
          
          if (headerRow) {
            const headers = headerRow.querySelectorAll('th')
            headers.forEach((th, index) => {
              if (columnWidths[index]) {
                th.style.width = `${columnWidths[index]}px`
                th.style.minWidth = `${columnWidths[index]}px`
                th.style.maxWidth = `${columnWidths[index]}px`
              }
            })
          }

          rows.forEach(row => {
            const cells = row.querySelectorAll('td')
            cells.forEach((td, index) => {
              if (columnWidths[index]) {
                td.style.width = `${columnWidths[index]}px`
                td.style.minWidth = `${columnWidths[index]}px`
                td.style.maxWidth = `${columnWidths[index]}px`
              }
            })
          })
        }
      }
    }
  }, [columnWidths])

  return (
    <div className={classNames} style={{ maxHeight: maxHeight, minHeight: minHeight }} ref={tableRef}>
      <table {...props}>
        {children}
      </table>
    </div>
  )
}
